import { render, staticRenderFns } from "./TruckShipmentForm.vue?vue&type=template&id=70c30085&scoped=true"
import script from "./TruckShipmentForm.vue?vue&type=script&lang=js"
export * from "./TruckShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./TruckShipmentForm.vue?vue&type=style&index=0&id=70c30085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c30085",
  null
  
)

export default component.exports